import { render, staticRenderFns } from "./purchase-amount-form.vue?vue&type=template&id=58514bef&scoped=true&"
import script from "./purchase-amount-form.vue?vue&type=script&lang=js&"
export * from "./purchase-amount-form.vue?vue&type=script&lang=js&"
import style0 from "./purchase-amount-form.vue?vue&type=style&index=0&id=58514bef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58514bef",
  null
  
)

export default component.exports